
import { computed, defineComponent, reactive } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { delivery } from '@/core/realisations/delivery.realisation'
import { useFormData } from '@/common/composable/useFormData'

export default defineComponent({
    components: {
        NewModal,
        NewInput,
        FileReader,
        NewButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()
        const { getFormData } = useFormData()

        const state = reactive({
            is_loading: false,
            //
            file: [] as File[],
            date: null as string | null,
        })

        const validation$ = useVuelidate(
            {
                file: { required },
                date: { required },
            },
            state
        )

        const onSubmit = async () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            try {
                state.is_loading = true

                const payload = {
                    date: state.date?.split('T').join(' '),
                    file: state.file[0],
                }

                await delivery.massApprove(getFormData(payload))
                notifications.notify({ title: 'Успешное массовое закрытие!', type: 'success' })

                emit('submit')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const isLoading = computed(() => {
            return props.loading || state.is_loading
        })

        return {
            state,
            validation$,
            onSubmit,
            onCancel,
            isLoading,
        }
    },
})
